import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup, HookFormRadioButton } from "components";
import { ZeroCostProgramTypes } from "types";
import {
	float2Normalizer,
	maxValue100,
	onlyPercent,
	required,
} from "validators";

type ZeroCostProcessingProps = {
	isLoading?: boolean;
};

const ZeroCost = ({ isLoading = false }: ZeroCostProcessingProps) => {
	const { register, watch } = useFormContext();

	const programType = parseInt(watch(`zeroCostProgramType`));

	return (
		<div data-autotest="zeroCostProcessingSection">
			<p>Zero-cost Processing</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						register={register}
						id="programTypeNone"
						name={`zeroCostProgramType`}
						value={ZeroCostProgramTypes.None.value?.toString()}
						label={ZeroCostProgramTypes.None.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						register={register}
						id="programTypeCashDiscount"
						name={`zeroCostProgramType`}
						value={ZeroCostProgramTypes.CashDiscount.value?.toString()}
						label={ZeroCostProgramTypes.CashDiscount.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						register={register}
						id="programTypeDuoPricing"
						name={`zeroCostProgramType`}
						value={ZeroCostProgramTypes.DuoPricing.value?.toString()}
						label={ZeroCostProgramTypes.DuoPricing.displayName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						register={register}
						id="programTypeSurcharge"
						name={`zeroCostProgramType`}
						value={ZeroCostProgramTypes.Surcharge.value?.toString()}
						label={ZeroCostProgramTypes.Surcharge.displayName}
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
			{programType !== ZeroCostProgramTypes.None.value && (
				<Row className="form-group">
					<Col md={5}>
						<HookFormInputGroup
							name={`zeroCostAmount`}
							register={register}
							label="Zero Cost Processing, %"
							colInput={6}
							colLabel={6}
							blurLoading={isLoading}
							placeholder="0.00"
							validator={{ required, maxValue100 }}
							normalize={onlyPercent}
							normalizeOnBlur={float2Normalizer}
							showRequiredMark
						/>
					</Col>
				</Row>
			)}
		</div>
	);
};

export default ZeroCost;
